import React from 'react'
import styled from 'styled-components'
import { Slideshow } from './Slideshow'
import { breakpointUpTo } from 'utils/breakpoints'
import { IHeroCarouselImages } from '../../../graphql/types'

const StyledImageWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-column: 1/-1;
  height: 100%;
  background: ${({ theme }) => theme.colors.white};

  > *:first-child {
    grid-column: 1/-1;

    ${({ theme }) => breakpointUpTo(theme.breakpoints.md)} {
      display: none;
    }
  }
`

type Props = {
  images: IHeroCarouselImages
}

export const ProductsSlideshow = ({ images }: Props) => {
  return (
    <StyledImageWrapper>
      <Slideshow images={images.top} variant="top" />
      <Slideshow images={images.bottomLeft} variant="bottomLeft" />
      <Slideshow images={images.bottomRight} variant="bottomRight" />
    </StyledImageWrapper>
  )
}
